import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.prod';
import { EResponseBase } from '../data/base/ResponseBase';  
import { InternshipApplicationDto } from '../data/ApplicationDto';
import { Filters } from '../models/filters.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApplicationService {

  constructor(private http: HttpClient) { }

  saveApplication(application: InternshipApplicationDto){
    return this.http.post<EResponseBase<InternshipApplicationDto>>(`${environment.url}/InternshipApplication/SaveApplication`, application);
  }
  GetFilteredApplications(filters: Filters): Observable<any> {
    
    let params = new HttpParams()
    .set('FullName', filters.FullName || '')
    // .set('FromDate', filters.FromDate ? filters.FromDate.toISOString() : '')
    // .set('ToDate', filters.ToDate ? filters.ToDate.toISOString() : '')
    .set('page', filters.page.toString())
    .set('pageSize', filters.pageSize.toString());

    // Manejar FromDate
    if (filters.FromDate) { // filters.FromDate es Date | null, así que esto verifica que no sea null
      // Ya debería ser un objeto Date si el componente lo asignó correctamente
      // Pero por si acaso, o si viene como una cadena que puede parsearse a Date:
      const fromDateObject = new Date(filters.FromDate); // Si ya es Date, new Date(dateObj) devuelve una copia. Si es string, intenta parsearlo.

      if (!isNaN(fromDateObject.getTime())) { // Verifica que la conversión a Date fue válida
        params = params.set('fromDate', fromDateObject.toISOString()); // Convierte a string ISO
      } else {
        console.warn('ApplicationService: El FromDate recibido no es una fecha válida o no se pudo convertir:', filters.FromDate);
        // Podrías optar por no enviar el parámetro o lanzar un error.
      }
    }

    // Manejar ToDate
    if (filters.ToDate) {
      const toDateObject = new Date(filters.ToDate);
      if (!isNaN(toDateObject.getTime())) {
        params = params.set('toDate', toDateObject.toISOString());
      } else {
        console.warn('ApplicationService: El ToDate recibido no es una fecha válida o no se pudo convertir:', filters.ToDate);
      }
    }

  return this.http.get(`${environment.url}/InternshipApplication/GetFilteredApplication`, { params });
  }

}
